<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(props.content).formattedMessage;
});
</script>

<template>
  <!-- dir="auto" lets the browser detect the text's base direction per message,
       so Arabic renders right-to-left (correct punctuation/number placement) while
       English stays left-to-right -->
  <span
    v-dompurify-html="formattedContent"
    dir="auto"
    class="prose prose-bubble"
  />
</template>
